import { render, staticRenderFns } from "./ItsLogisticTransfer.vue?vue&type=template&id=57f58a7b&scoped=true&"
import script from "./ItsLogisticTransfer.vue?vue&type=script&lang=js&"
export * from "./ItsLogisticTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f58a7b",
  null
  
)

export default component.exports